import type { UIMatch } from 'react-router';

import type { CmsSplatPageLoaderData } from './CmsSplatPageLoaderData';

export function isSearchLandingPageSSRMatch(
  match: UIMatch,
): match is UIMatch<
  Extract<CmsSplatPageLoaderData, { type: 'SEARCH_LANDING_PAGE' }>
> {
  if (match.id !== 'cms-route') return false;

  const data = match.loaderData as CmsSplatPageLoaderData | undefined;
  if (!data) return false;

  return data.type === 'SEARCH_LANDING_PAGE';
}
